import gql from 'graphql-tag'

export const contactSubscription = gql`
	subscription($userId: ID!) {
		Contacts(filter: {
			mutation_in: [UPDATED, DELETED]
			node: { user: { id: $userId } }
		}) {
			mutation
			node {
				id
			}
		}
	}
`



// WEBPACK FOOTER //
// ./src/graphql/subscriptions/contacts.js